import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const { Option } = Select;

const AddToleForm = () => {
    const [loading, setLoading] = useState(false);
    const [munWards, setMunWards] = useState([]);

    useEffect(() => {
        // Fetch municipal wards from the API
        axios
            .get('https://ward3-chandrapur-api.palikaapp.com/api/ward/all')
            .then((response) => {
                setMunWards(response.data);
            })
            .catch((error) => {
                console.error('Error fetching wards:', error);
                message.error('Failed to load municipal wards.');
            });
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        axios
            .post('https://ward3-chandrapur-api.palikaapp.com/api/mun-tole/save', {
                id: values.id,
                name: values.name,
                phone: values.phone,
                email: values.email,
                munWard: values.munWard,
            })
            .then(() => {
                message.success('Municipal Tole saved successfully!');
                setLoading(false);
            })
            .catch((error) => {
                message.error('Failed to save Municipal Tole.');
                console.error('Error:', error);
                setLoading(false);
            });
    };

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
             <Header />
            {/* Sidebar and Header */}
            <div className="lg:w-1/5 pt-20">
               
                <Sidebar />
            </div>

            {/* Form Section */}
            <div className="lg:w-4/5 p-6 pt-20 mt-5">
                <h1 className="text-xl lg:text-2xl font-bold mb-6 text-center lg:text-center">
                    टोलको फारम
                </h1>
                <div className="flex justify-center">
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-md bg-white p-6 shadow-lg rounded-md"
                    >
                        <Form.Item
                            label="नाम"
                            name="name"
                            rules={[{ required: true, message: 'Please input the name!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="फोन"
                            name="phone"
                            rules={[{ required: true, message: 'Please input the phone number!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="इमेल"
                            name="email"
                            rules={[
                                { required: true, message: 'Please input the email!' },
                                { type: 'email', message: 'Please enter a valid email!' },
                            ]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="वडा"
                            name="munWard"
                            rules={[{ required: true, message: 'Please select the municipal ward!' }]}
                        >
                            <Select
                                placeholder="Select a municipal ward"
                                className="border-gray-300 rounded-md"
                            >
                                {munWards.map((ward) => (
                                    <Option key={ward.id} value={ward.name}>
                                        {ward.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default AddToleForm;
